import React from "react"
import TableComponent from "../../components/TableComponent"
import Layout from "../../components/Layout"

const HomePage = () => {
  return (
    <Layout>
      <TableComponent />
    </Layout>
  )
}

export default HomePage
